import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import Lightbox from "react-image-lightbox";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-image-lightbox/style.css";

const EventsCarousel = () => {
  const [events, setEvents] = useState([]);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const API ="https://login.abhedasramam.org/myapp/api/uploads/get_event.php";

  // ✅ BASE URL
  const BASE_URL = "https://login.abhedasramam.org/myapp/";

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await axios.get(API);
      console.log("API DATA:", res.data);
      setEvents(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  // ✅ USE file_path HERE
  const getFileUrl = (item) => {
    const file = item.file_path || "";

    if (!file) return "";

    if (file.startsWith("http")) return file;

    return BASE_URL + file;
  };

  // ✅ PDF CHECK
  const isPDF = (url) => {
    return typeof url === "string" && url.toLowerCase().endsWith(".pdf");
  };

  // ✅ ARROWS
  const NextArrow = ({ onClick }) => (
    <div style={arrowRight} onClick={onClick}>
      ❯
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div style={arrowLeft} onClick={onClick}>
      ❮
    </div>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ textAlign: "center", marginBottom: "20px",fontSize:'18pt',fontWeight:'600' }}>
        Latest Events
      </h2>

      <Slider {...settings}>
        {events.map((item, index) => {
          const fileUrl = getFileUrl(item);

          return (
            <div key={index}>
              <div style={cardStyle}>
                

                {fileUrl ? (
                  isPDF(fileUrl) ? (
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={buttonStyle}
                    >
                      View More
                    </a>
                  ) : (
                    <img 
                      src={fileUrl}
                      alt={item.name}
                      style={imgStyle}
                      onClick={() => {
                        setPhotoIndex(index);
                        setIsOpen(true);
                       }}
                    />
                  )
                ) : (
                  <p>No File</p>
                )}

                <h3 style={{ textAlign: "center", marginBottom: "20px",fontSize:'15pt',fontWeight:'600',fontFamily:'anek malayalam' }}>{item.name || "No Title"}</h3>
              </div>
            </div>
          );
        })}
      </Slider>

      {/* ✅ LIGHTBOX */}
      {isOpen && (
        <Lightbox
          mainSrc={getFileUrl(events[photoIndex])}
          nextSrc={getFileUrl(
            events[(photoIndex + 1) % events.length]
          )}
          prevSrc={getFileUrl(
            events[(photoIndex + events.length - 1) % events.length]
          )}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + events.length - 1) % events.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % events.length)
          }
        />
      )}
    </div>
  );
};

// ✅ STYLES
const cardStyle = {
  padding: "15px",
  textAlign: "center",
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  margin: "10px",
  height:"400px",
  display:"flex",
  alignItems:"center",
  justifyContent:"start",
  flexDirection:"column",
  border:"2px groove orange",
};

const imgStyle = {
//   width: "100%",
   width: "100%",
  height: "280px",
  objectFit: "cover",
  borderRadius: "10px",
  cursor: "pointer",
  marginBottom:"20px",
};

const arrowLeft = {
  position: "absolute",
  top: "40%",
  left: "-10px",
  zIndex: 2,
  fontSize: "30px",
  cursor: "pointer",
  color: "#000",
};

const arrowRight = {
  position: "absolute",
  top: "40%",
  right: "-10px",
  zIndex: 2,
  fontSize: "30px",
  cursor: "pointer",
  color: "#000",
};

const buttonStyle = {
  display: "inline-block",
  marginTop: "15px",
  padding: "10px 18px",
  background: "#007bff",
  color: "#fff",
  borderRadius: "6px",
  textDecoration: "none",
  fontWeight: "bold",
};

export default EventsCarousel;